var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"wrap":""}},[_c('v-btn',{staticStyle:{"float":"right"},on:{"click":_vm.OpenCourseModal}},[_vm._v("Add Course SEO")])],1),_c('app-add-course-seo',{ref:"GetDetails",attrs:{"dialog":_vm.AddCourseSEODialog},on:{"close":_vm.CloseCourseModal}}),_c('app-course-seo-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }